// extracted by mini-css-extract-plugin
export default {"pdoModels":"PDO_pdoModels__cqxey","PDOnumber":"PDO_PDOnumber__bYqGh","title":"PDO_title__ca9n3","plusImg":"PDO_plusImg__RS1JB","minusImg":"PDO_minusImg__aDLuq"};